<template>
    <div>
        <div v-if="name === 'addItemToCart'">
            <add-item-to-cart 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'applyPromoCode'">
            <apply-promo-code :rule="rule"/>
        </div>
        <div v-if="name === 'awardPointsOnRedemption'">
            <award-points-on-redemption
                :alldeals="alldeals"
                :allproducts="allproducts"
                :deals="deals"
                :products="products"
                :rule="rule"
                :venues="venues"
            />
        </div>
        <div v-if="name === 'itemRequiresItem'">
            <item-requires-item 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'limitPromoQty'">
            <limit-promo-qty :rule="rule" />
        </div>
        <div v-if="name === 'maxPurchaseQty' || name === 'maxTotalPurchaseQty'">
            <max-purchase-qty 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'messageOnTotalOfferRedemptions'">
				<messageontotalredemptions :key="rule.id" :rule="rule" :products="productgroups" :messageLists="messageLists"/>
			</div>
        <!-- <div v-if="name === 'minPurchaseQty'">
            <max-purchase-qty 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div> -->
        <div v-if="name === 'proceedToCheckout'">
            <proceed-to-checkout 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'promoCodeRequired'">
            <promo-code-required 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :rule="rule" 
                :promos="promos"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'skipCheckout'">
            <skip-checkout 
                :name="name" 
                :allpackages="allpackages" 
                :alldeals="alldeals" 
                :allproducts="allproducts" 
                :packages="packages" 
                :deals="deals" 
                :products="products" 
                :rule="rule"
                :index_position="index_position"
                :key="rule.id"
            />
        </div>
        <div v-if="name === 'zipCode'">
            <zip-code :rule="rule" :index_position="index_position" :key="rule.id" />
        </div>
    </div>
</template>

<script>
import addItemToCart from './addItemToCart';
import applyPromoCode from './applyPromoCode';
import itemRequiresItem from './itemRequiresItem';
import limitPromoQty from './limitPromoQty';
import maxPurchaseQty from './maxPurchaseQty';
import messageOnTotalOfferRedemptions from './messageOnTotalOfferRedemptions';
// import minPurchaseQty from './minPurchaseQty';
import proceedToCheckout from './proceedToCheckout';
import promoCodeRequired from './promoCodeRequired';
import skipCheckout from './skipCheckout';
import zipCode from './zipCode';
import awardPointsOnRedemption from "./awardPointsOnRedemption";

    export default {
        props: {
            name: String,
            allpackages: Array,
            alldeals: Array,
            allproducts: Array,
            packages: Array,
            deals: Array,
            products: Array,
            venues: Array,
            productgroups: Array,
            rule: Object,
            promos: Array,
            index_position: Number,
            messageLists: {
                type: Array,
                default() { return [] }
            }
        },
        components: {
            'add-item-to-cart': addItemToCart,
            'apply-promo-code': applyPromoCode,
            'award-points-on-redemption': awardPointsOnRedemption,
            'item-requires-item': itemRequiresItem,
            'limit-promo-qty': limitPromoQty,
            'max-purchase-qty': maxPurchaseQty,
            'messageontotalredemptions': messageOnTotalOfferRedemptions,
            // 'min-purchase-qty': minPurchaseQty,
            'proceed-to-checkout': proceedToCheckout,
            'promo-code-required': promoCodeRequired,
            'skip-checkout': skipCheckout,
            'zip-code': zipCode,
        },
        mounted() {
            if( this.rule.settings && Array.isArray(this.rule.settings) && !this.rule.settings.length )
                this.rule.settings = {}; // json decode is returning a empty object as an empty array from the db. It breaks the rule component.

        }
    }
</script>